import React, { createContext, useContext, useReducer } from 'react';

const snackbarDefault = { isOpen: false, message: null, variant: 'info' };

let reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_PROFILE':
      return { ...state, profile: action.profile};
    case 'UPDATE_RESTRICTIONS':
      return { ...state, restrictions: action.restrictions };
    case 'CLEAR_PROFILE':
      return { ...state, detail: null };
    case 'SET_PERMISSIONS':
      return { ...state, permissions: action.permissions };
      case 'SET_SNACKBAR':
      return {
        ...state,
        snackbar: {
          ...snackbarDefault,
          ...action.snackbar,
        },
      };
    default:
      return state;
  }
};

const initialState = {
  profile: null,
  restrictions: null,
  permissions: null,
  snackbar: snackbarDefault,
};

export const QaDetailContext = createContext(initialState);

export const QaDetailContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <QaDetailContext.Provider value={{ state, dispatch }}>{props.children}</QaDetailContext.Provider>;
};

